import { useTranslation } from '@cobliteam/i18n';
import { Switch, Typography } from '@cobliteam/ui/components';

interface ChecklistStatusToggleProps {
  isActive: boolean;
  onActiveChange: (active: boolean) => void;
}

const ChecklistStatusToggle = ({ isActive, onActiveChange }: ChecklistStatusToggleProps) => {
  const { t } = useTranslation('checklists');

  return (
    <div className='flex items-center gap-3'>
      <Switch checked={isActive} onCheckedChange={onActiveChange} size='md' />
      <Typography variant='body'>{isActive ? t('checklist_status') : t('checklist_deactivated')}</Typography>
    </div>
  );
};

export default ChecklistStatusToggle;
